import React, { PureComponent } from 'react';
import { Formik, Form, Field } from 'formik';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
});

class AboutMeForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, {}, {
      about: props.profile.about,
      loyalties: props.profile.loyalties.slice(0),
      newLoyalty: ''
    });
  }

  componentWillReceiveProps(newProps) {
  }

  removeLoyalty(loyalty, about) {
    let loyalties = this.state.loyalties.slice(0);
    loyalties.splice(loyalties.indexOf(loyalty), 1);
    this.setState({
      loyalties: loyalties,
      about: this.state.about
    })
  }

  addLoyalty(newLoyalty, about) {
    if (!newLoyalty)
      return;

    newLoyalty = newLoyalty.trim();
    if (!!newLoyalty && this.state.loyalties.indexOf(newLoyalty) === -1) {
      this.setState({
        loyalties: this.state.loyalties.concat(newLoyalty),
        about: about
      })
    }
  }

  render() {
    let { onSubmit, onCancel } = this.props;
    let initValues = this.state
    return (
      <div className="row"><div className="col">
        <Formik
          enableReinitialize={true}
          initialValues={initValues}
          onSubmit={onSubmit}>

          {({ values, ...rest }) => (
            <Form>
              <div className="row">
                <div className="col"><h2>About Me</h2></div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="fieldgroup">
                    <Field
                      name="about"
                      component="textarea"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <h3>Loyalties</h3>
                  <ul>
                    {values.loyalties.map((loyalty, index) => {
                      return (
                        <li key={index}>
                          <span>{loyalty}</span>
                          <i className="fas fa-times ml-3"
                            onClick={() => { this.removeLoyalty(loyalty, values.about); }} />
                        </li>
                      )
                    })}
                  </ul>
                </div>
                {(values.loyalties.length < 5) &&
                  (<div className="col"><div className="row"><div className="col pr-0">
                    <div className="fieldgroup">
                      <Field
                        name="newLoyalty"
                        type="text"
                        className="form-control"
                        placeholder="Add Loyalty..."

                      />
                    </div>
                  </div>
                    <div className="col-3 col-sm-2 d-flex align-center">
                      <button type="button" className="btn btn-secondary pr-2 pl-2 ml-auto" onClick={(e) => {
                        e.preventDefault();
                        this.addLoyalty(values.newLoyalty, values.about);
                      }}>Add</button>
                    </div></div></div>)
                }
              </div>
              <div className="button-row row mt-3">
                <div className="col">
                  <div className="mt-2">
                    <label className="link" onClick={onCancel}>Cancel</label>
                  </div>
                </div>
                <div className="col text-right">
                  <button className="btn btn-primary" type="submit">Save</button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div></div>
    )
  }
}

export default connect(mapStateToProps)(AboutMeForm);
